import api from "@/lib/api";

// Lightweight in-memory TTL cache for GET requests (per page session).
// Returns an axios-like { data } so it can drop into existing api.get calls.
const store = new Map();

export async function cachedGet(url, { ttl = 60000, params } = {}) {
  const key = url + (params ? JSON.stringify(params) : "");
  const hit = store.get(key);
  if (hit && Date.now() - hit.ts < ttl) return { data: hit.data };
  const res = await api.get(url, params ? { params } : undefined);
  store.set(key, { ts: Date.now(), data: res.data });
  return res;
}

export function invalidate(prefix) {
  for (const k of Array.from(store.keys())) {
    if (k.startsWith(prefix)) store.delete(k);
  }
}

export function clearCache() {
  store.clear();
}
